const body = document.documentElement;
const scrollBlock = document.querySelector('.scroll');
const header = document.querySelector('.header');
const videos = document.querySelectorAll('.scroll__video');
const scrollArea = document.querySelector('.scroll__area');
const preview = document.querySelector('.scroll__preview');
const bottom = document.querySelector('.scroll__bottom');
const inner = document.querySelector('.scroll__inner');
const firstText = document.querySelector('.scroll__block--first .scroll__text');
const thirdText = document.querySelector('.scroll__block--third .scroll__text');
const thirdBlock = document.querySelector('.scroll__block--third');
const expertise = document.querySelector('.our-expertise')
const expertiseNew = document.querySelector('.our-expertise-new')
let thirdStep = false
let currentIndex = 0;
let isLocked = false;
let isStart = false;
let allowScroll = false;
let wheelLocked = false;
let activeSlide = true;
let timeouts = [];
const isMobile = window.innerWidth <= 991;
expertise.classList.add('dn')

setTimeout(() => {
  body.classList.remove('overflow');
  window.scrollTo(0, 0);
  document.documentElement.scrollTop = 0;
  document.body.scrollTop = 0;
  body.classList.add('overflow');
}, 1)

if (!isMobile) {
  window.addEventListener('load', () => {
    setTimeout(() => {
      body.classList.remove('overflow');
      window.scrollTo(0, 0);
      document.documentElement.scrollTop = 0;
      document.body.scrollTop = 0;
      body.classList.add('overflow');
    }, 1)

  });
}


//== PREVIEW ==
function showPreview() {
  preview.classList.remove('hidden');
  isStart = false;
  header.classList.remove('small');
  videos.forEach((video, i) => {
    video.pause();
    video.currentTime = 0;
    const block = video.parentElement;
    block.querySelectorAll('.scroll__title').forEach(title => title.classList.remove('active'));
    block.querySelector('.scroll__text').classList.remove('active');
  });
  setTimeout(() => {
    bottom.classList.add('visible');
    inner.classList.add('visible');
  }, 200);
  isLocked = false;
}

function closePreview() {
  setTimeout(() => {
    isStart = true;
    header.classList.add('small');
    preview.classList.add('hidden');
    bottom.classList.remove('visible');
    inner.classList.remove('visible');

    setTimeout(() => {
      preview.classList.remove('hidden');
      bottom.classList.add('visible');
      inner.classList.add('visible');
    }, 1000)



    scrolled = true;
    allowScroll = true;
    header.classList.add('black');
    scrollBlock.classList.add('free');

    const ourExpertise = document.querySelector('.our-expertise');
    const ourExpertiseNew = document.querySelector('.our-expertise-new');
    if (window.innerWidth < 991) {
      $('html, body').animate(
        { scrollTop: ourExpertise.getBoundingClientRect().top + window.scrollY + 50 },
        1000
      );

    } else {
      $('html, body').animate(
        { scrollTop: ourExpertiseNew.getBoundingClientRect().top + window.scrollY + 50 },
        1000
      );
      ourExpertiseNew.classList.add('inactive')

      setTimeout(() => {

        setTimeout(() => {
          ourExpertiseNew.classList.remove('inactive')
        }, 2000)


        const blocks = document.querySelectorAll('.our-expertise-new__block');
        blocks.forEach((block, i) => {
          if (i === 0) {
            block.classList.add('active');
          } else {
            block.classList.add('not-active');
          }
        });
      }, 600)
    }


    setTimeout(() => {
      body.classList.remove('overflow');
      scrolled = false;
      thirdStep = false;
    }, 1100);


  }, 50);
}

//== SCROLL HANDLER ==
function scrollHandler(e) {
  if (wheelLocked) return;
  wheelLocked = true;

  setTimeout(() => {
    wheelLocked = false;
  }, 500);

  if (allowScroll) return;

  const direction = e.deltaY > 0 ? 1 : -1;
  const newIndex = currentIndex + direction;

  if (newIndex === 1 && !isStart) {
    closePreview();
  } else if (newIndex === -1) {
    showPreview();
  }
}

//== BACK TO SCROLL ==
function backToScroll() {
  allowScroll = false;
  isStart = true;
  body.classList.add('overflow');
  header.classList.remove('black');
  showPreview();
  currentIndex = 0;
}

//== MOBILE TOUCH HANDLERS ==
let touchStartY = 0;

function handleTouchStart(e) {
  touchStartY = e.touches[0].clientY;
}

function handleTouchEnd(e) {
  const touchEndY = e.changedTouches[0].clientY;
  scrollHandler({ deltaY: touchStartY - touchEndY });
}

window.addEventListener('touchstart', handleTouchStart, { passive: true });
window.addEventListener('touchend', handleTouchEnd, { passive: true });

window.addEventListener('touchmove', e => {
  if (!scrollBlock.classList.contains('dn')) return;

  const scrollTop = window.pageYOffset || document.documentElement.scrollTop;
  const currentY = e.touches[0].clientY;
  const swipeUp = touchStartY - currentY > 10;
  const swipeDown = currentY - touchStartY > 10;

  if (scrollTop === 0 && swipeDown) {
    const carousel = document.querySelectorAll('.our-expertise__slide-item');

    if (!activeSlide) {
      backToScroll();
      activeSlide = true;
    }

    if (carousel[0].classList.contains('active')) {
      activeSlide = false;
    }
  }
});

document.querySelectorAll('.scroll__block--third .scroll__video').forEach(video => {
  const observer = new IntersectionObserver(entries => {
    entries.forEach(entry => {
      if (document.querySelector('.scroll__block--third').classList.contains('active')) {
        if (entry.isIntersecting) {
          video.play().catch(() => { });
        } else {
          video.pause();
        }
      }
    });
  }, {
    threshold: 0.05
  });

  observer.observe(video);
});


let activeStartTime = null;
let scrolled = false
const observer = new MutationObserver(mutationsList => {
  mutationsList.forEach(mutation => {
    if (mutation.attributeName === 'class') {
      if (thirdText.classList.contains('active')) {
        activeStartTime = Date.now();
      } else {
        activeStartTime = null;
      }
    }
  });
});
thirdText && observer.observe(thirdText, { attributes: true });



let touchStart = 0;
let touchEnd = 0;

window.addEventListener('touchstart', (e) => {
  touchStart = e.changedTouches[0].clientY;
});

window.addEventListener('touchend', (e) => {
  touchEnd = e.changedTouches[0].clientY;
  handleScrollLikeAction(touchStart - touchEnd);
});


window.addEventListener('wheel', (e) => {
  handleScrollLikeAction(e.deltaY, e);
});

function handleScrollLikeAction(deltaY, e) {
  scrollHandler(e);
  if (!scrollBlock.classList.contains('free')) return;

  const scrollTop = window.pageYOffset || document.documentElement.scrollTop;
  if (scrollTop === 0 && deltaY < 0) {
    backToScroll();
    scrollBlock.classList.remove('free');
  }
}
